// src/reducers/data.js

import ActionType from 'actions/ActionType'
import { omit } from 'lodash'

export default (state = {}, action) => {
  const switchObj = {
    [ActionType.Data.LIST_SUCCESS]: () => {
      if (
        !action.payload /* ||
        (typeof action.payload === 'object' &&
          !Object.keys(action.payload).length) */
      ) {
        return {
          ...state,
          [action.entityType]: { ...state[action.entityType] },
        }
      }

      if (
        Array.isArray(action.payload) &&
        // TODO: maybe create mapping for one-offs
        action.entityType?.slice?.(0, 6) !== 'inbox/' &&
        action.entityType !== 'userpin'
      ) {
        let payload = action.payload

        if (action.filter) {
          payload = action.filter(action.payload)
        }

        return {
          ...state,
          [action.entityType]: payload.reduce(
            (newEntitiesByID, entity) => {
              const newEntity = action.returnItem
                ? action.returnItem
                : action.extraProperties
                ? { ...entity, ...action.extraProperties }
                : entity

              newEntitiesByID[
                action.idString
                  ? typeof action.idString === 'string'
                    ? entity[action.idString]
                    : action.idString(entity)
                  : entity.id
              ] = newEntity

              return newEntitiesByID
            },
            action?.replaceList ? {} : { ...state[action.entityType] },
          ),
        }
      }

      return state
    },
    [ActionType.Data.CREATE_SUCCESS]: () => {
      if (action.noReturnValue || action.entityType === 'userpin') {
        return state
      }

      return {
        ...state,
        [action.entityType]: {
          ...state[action.entityType],
          [action.payload.id]: action.payload,
        },
      }
    },
    [ActionType.Data.READ_SUCCESS]: () => {
      if (action.idString === 'none') {
        return {
          ...state,
          [action.entityType]: action.payload,
        }
      }

      if (action.returnType === 'array') {
        return {
          ...state,
          [action.entityType]: {
            ...(state[action.entityType] || {}),
            [action.entityID]: action.payload,
          },
        }
      }

      return {
        ...state,
        [action.entityType]: {
          ...(state[action.entityType] || {}),
          [action.id
            ? action.id
            : action.idString
            ? action.payload[action.idString]
            : action.payload.id]: action.payload,
        },
      }
    },
    [ActionType.Data.UPDATE_SUCCESS]: () => {
      if (action.payload) {
        if (action.idString === 'none') {
          return {
            ...state,
            [action.entityType]: action.payload,
          }
        }

        return {
          ...state,
          [action.entityType]: {
            ...state[action.entityType],
            [action.idString
              ? action.payload[action.idString]
              : action.payload.id]: action.payload,
          },
        }
      }

      return state
    },
    [ActionType.Data.DELETE_SUCCESS]: () => {
      if (action.entityType && action.id && action.entityType !== 'userpin') {
        return {
          ...state,
          [action.entityType]: omit(state[action.entityType], action.id),
        }
      }
      return state
    },
  }

  // If the function returns falsey, a ternary is required because
  // if `|| state` is used, state will remain the same
  return switchObj?.[action?.type] ? switchObj[action?.type]?.() : state
}
